import InfoBox from 'components/InfoBox/InfoBox';
import SelectDropDown from 'components/SelectDropDown/SelectDropDown';
import { checkIntegrationData } from 'helper/Integration';
import { inject, observer } from 'mobx-react';
import { INTEGRATION } from 'models/Integration';
import React, { useEffect, useState } from 'react';
import { GitlabIntegrationStore } from 'stores/integrations/GitlabIntegrationStore';
import { ProjectStore } from 'stores/private/ProjectStore';

interface GitlabConfigurationProps {
  integrationID: string;
  index: number;
  gitlabIntegrationStore?: GitlabIntegrationStore;
  projectStore?: ProjectStore;
  onChange: (data: any) => any;
}

const GitlabConfiguration = ({
  integrationID,
  index,
  gitlabIntegrationStore,
  projectStore,
  onChange,
}: GitlabConfigurationProps) => {
  const project = projectStore?.currentProject;

  const [currentIntegrationInfo, setCurrentIntegrationInfo] = useState(
    {} as any,
  );

  // @ts-ignore
  const [projectID, setProjectID] = useState('');

  const projects = gitlabIntegrationStore?.projects;

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => {
    if (project && isMounted) {
      initialize();
    }
  }, [project, isMounted]);

  useEffect(() => {
    saveIntegrationInfo();
  }, [projectID]);

  const initialize = async () => {
    gitlabIntegrationStore!.setIntegrationID(integrationID);
    await gitlabIntegrationStore!.getProjects();

    if (
      !checkIntegrationData({
        project,
        integrationName: INTEGRATION.GITLAB,
        integrationID,
        actionIndex: index,
      })
    ) {
      return;
    }

    const integrationInfo =
      project?.integrations?.gitlab[integrationID]?.actions[index]
        ?.integrationInfo;

    setCurrentIntegrationInfo(integrationInfo);
  };

  const chooseRepository = async (repositoryId) => {
    setProjectID(repositoryId);
  };

  const saveIntegrationInfo = () => {
    const integrationInfo = {
      projectID,
    };

    onChange(integrationInfo);
  };

  return (
    <div className="configuration-container mt-30">
      <SelectDropDown
        className="mb-15"
        label="Projects"
        labelPropertyName="name_with_namespace"
        valuePropertyName="id"
        selectedItem={projects.find(
          (element) => element.id === currentIntegrationInfo?.projectID,
        )}
        isLoading={projects.length === 0}
        items={projects}
        onChange={(option) => {
          chooseRepository(option.id);
        }}
      />
      <InfoBox title="Info">
        <>It might take some time to fetch all the projects.</>
      </InfoBox>
    </div>
  );
};

export default inject(
  'gitlabIntegrationStore',
  'projectStore',
)(observer(GitlabConfiguration));
